type CancelIconProps = {
    width?: number;
    height?: number;
    className?: string;
};

const CancelIcon = ({ width = 12, height = 12, className }: CancelIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
    >
        <path
            d="M3 3L9 9M9 3L3 9"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
        />
    </svg>
);

export default CancelIcon;
